/* --------------------------------------------------------------------------------------
   deviceInfo.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class deviceInfoService {
    /*@ngInject*/
  constructor () {
    this.lang = null
  }
  get() {
    if (this.info == null) {
      return this.readDeviceInfo().then(info => {
        this.info = info
        return this.info
      })
    }
    else {
      return Promise.resolve(this.info)
    }
  }
  readDeviceInfo() {
    return new Promise((resolve, reject) => {
      getDeviceInfo(
        (info) => resolve(info),
        (error) => reject({method: 'readDeviceInfo', error})
      )
    })
  }
  getLanguage() {
    if (this.lang == null)
      this.lang = getLocalizationLanguage()

    return this.lang
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/deviceInfo.service.js